import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const restoreMacro = api(async function restoreMacro({ id }) {
    if (!id) return false
    return mutate(
        gql`
            mutation RestoreMacro($id: String!) {
                restoreMacro(id: $id)
            }
        `,
        { id },
        { returns: "restoreMacro" }
    )
})
